import * as React from "react";

const BlockFour = ({data}) => {
    return (
        <div className="row-fluid-wrapper row-depth-1 row-number-12 ">
            <div className="row-fluid ">
                <div className="span12 widget-span widget-type-cell full-width" data-widget-type="cell" data-x="0" data-w="12">

                    <div className="row-fluid-wrapper row-depth-1 row-number-13 ">
                        <div className="row-fluid ">
                            <div className="span12 widget-span widget-type-custom_widget visible-phone" data-widget-type="custom_widget" data-x="0" data-w="12">
                                <div id="hs_cos_wrapper_module_1536784684339159" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-space" data-hs-cos-general-type="widget" data-hs-cos-type="module"><span className="hs-horizontal-spacer"></span></div>

                            </div>
                        </div>
                    </div>

                    <div className="row-fluid-wrapper row-depth-1 row-number-14 ">
                        <div className="row-fluid ">
                            <div className="span12 widget-span widget-type-custom_widget hidden-phone" style={{height:"50px"}} data-widget-type="custom_widget" data-x="0" data-w="12">
                                <div id="hs_cos_wrapper_module_1536779580881118" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-space" data-hs-cos-general-type="widget" data-hs-cos-type="module"><span className="hs-horizontal-spacer"></span></div>

                            </div>
                        </div>
                    </div>

                    <div className="row-fluid-wrapper row-depth-1 row-number-15 ">
                        <div className="row-fluid ">
                            <div className="span1 widget-span widget-type-cell " data-widget-type="cell" data-x="0" data-w="1">

                            </div>
                            <div className="span10 widget-span widget-type-cell " data-widget-type="cell" data-x="1" data-w="10">

                                <div className="row-fluid-wrapper row-depth-1 row-number-16 ">
                                    <div className="row-fluid ">
                                        <div className="span12 widget-span widget-type-custom_widget " data-widget-type="custom_widget" data-x="0" data-w="12">
                                            <div id="hs_cos_wrapper_module_1536780558155147" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-rich_text widget-type-rich_text" data-hs-cos-general-type="widget" data-hs-cos-type="module"><span id="hs_cos_wrapper_module_1536780558155147_" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_rich_text" data-hs-cos-general-type="widget" data-hs-cos-type="rich_text"><h2 id="faq" className="headlines" style={{textAlign: "center", fontSize: "30px"}} dangerouslySetInnerHTML={{__html: data.title}}></h2></span></div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="span1 widget-span widget-type-cell " data-widget-type="cell" data-x="11" data-w="1">

                            </div>
                        </div>
                    </div>

                    <div className="row-fluid-wrapper row-depth-1 row-number-17 ">
                        <div className="row-fluid ">
                            <div className="span1 widget-span widget-type-cell " data-widget-type="cell" data-x="0" data-w="1">

                            </div>
                            <div className="span10 widget-span widget-type-cell " data-widget-type="cell" data-x="1" data-w="10">

                                <div className="row-fluid-wrapper row-depth-1 row-number-18 ">
                                    <div className="row-fluid ">
                                        <div className="span12 widget-span widget-type-custom_widget hidden-phone" style={{height:"30px"}} data-widget-type="custom_widget" data-x="0" data-w="12">
                                            <div id="hs_cos_wrapper_module_1536784543377114" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-space" data-hs-cos-general-type="widget" data-hs-cos-type="module"><span className="hs-horizontal-spacer"></span></div>

                                        </div>
                                    </div>
                                </div>

                                <div className="row-fluid-wrapper row-depth-1 row-number-19 ">
                                    <div className="row-fluid ">
                                        <div className="span12 widget-span widget-type-custom_widget " data-widget-type="custom_widget" data-x="0" data-w="12">
                                            <div id="hs_cos_wrapper_module_1536779590734124" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module" data-hs-cos-general-type="widget" data-hs-cos-type="module">
                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question1.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question1.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question2.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question2.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question3.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question3.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question4.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question4.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question5.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question5.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question6.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question6.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question7.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question7.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question8.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question8.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question9.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question9.answer}}>
                                                    
                                                </div>

                                                <button className="PhyAccordion" dangerouslySetInnerHTML={{__html: data.question10.question}}></button>
                                                <div className="PhyPanel" dangerouslySetInnerHTML={{__html: data.question10.answer}}>
                                                    
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="row-fluid-wrapper row-depth-1 row-number-20 ">
                                    <div className="row-fluid ">
                                        <div className="span12 widget-span widget-type-custom_widget visible-phone" style={{height:"30px"}} data-widget-type="custom_widget" data-x="0" data-w="12">
                                            <div id="hs_cos_wrapper_module_1536784546279118" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-space" data-hs-cos-general-type="widget" data-hs-cos-type="module"><span className="hs-horizontal-spacer"></span></div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="span1 widget-span widget-type-cell " data-widget-type="cell" data-x="11" data-w="1">

                            </div>
                        </div>
                    </div>

                    <div className="row-fluid-wrapper row-depth-1 row-number-21 ">
                        <div className="row-fluid ">
                            <div className="span12 widget-span widget-type-custom_widget hidden-phone" style={{height:"50px"}} data-widget-type="custom_widget" data-x="0" data-w="12">
                                <div id="hs_cos_wrapper_module_1536779583806120" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-space" data-hs-cos-general-type="widget" data-hs-cos-type="module"><span className="hs-horizontal-spacer"></span></div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default BlockFour;